export default "__VITE_ASSET__QJAFXYHh__"